export var color;
(function (color) {
    color["primary"] = "#5CC4BD";
    color["secondary"] = "#37474F";
})(color || (color = {}));
//# sourceMappingURL=color.js.map